var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aha-section"},[_c('div',{staticClass:"aha-section-header"},[_vm._t("header")],2),(_vm.hasSubHeader)?_c('div',{staticClass:"aha-section-subheader"},[_vm._t("sub-header")],2):_vm._e(),_c('div',{staticClass:"aha-section-body"},[_vm._t("body")],2),_c('div',{staticClass:"aha-section-footer"},[_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }